"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const formatPrice = function () {
  let price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "0";
  let lang = arguments.length > 1 ? arguments[1] : undefined;
  const formattedPrice = typeof price === "string" ? price.replace(",", ".") : price;
  return new Intl.NumberFormat(lang, {
    style: "currency",
    currency: "EUR"
  }).format(parseFloat(formattedPrice));
};
var _default = exports.default = formatPrice;